/** @jsx jsx */
import { useAnalytics } from '@arfabrands/gatsby-theme-assembly'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { jsx } from 'theme-ui'

const KitLink = ({ slug, children, sx, ...props }) => {
  const { trackClickProduct } = useAnalytics()

  const url = `/bundles/${slug}/`

  return (
    <Link
      to={url}
      onClick={() => trackClickProduct(slug)}
      sx={{
        ...sx
      }}
      {...props}
    >
      {children}
    </Link>
  )
}

KitLink.propTypes = {
  slug: PropTypes.string.isRequired,
  children: PropTypes.node
}

export default KitLink
